// extracted by mini-css-extract-plugin
module.exports = {"scoreWrapper":"styles_scoreWrapper__u69W8","score":"styles_score__3NTcx","scoreLabel":"styles_scoreLabel__q00qj","stars":"styles_stars__vbOYZ"};